module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "C123"
  }, [_c('em', [_c('a', {
    attrs: {
      "id": "page_x"
    }
  }, [_vm._v("Contents")])])]), _c('a', {
    attrs: {
      "id": "page_x"
    }
  }), _c('p', {
    staticClass: "C124"
  }, [_c('a', {
    attrs: {
      "id": "page_x"
    }
  }, [_c('em')]), _c('em', [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Foreword#page_xii",
      "id": "id_1219"
    }
  }, [_vm._v("Foreword")]), _vm._v(" by Joan Waugh")])]), _vm._v(" "), _c('p', {
    staticClass: "C125"
  }, [_c('em', [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Acknowledgments#page_xiv",
      "id": "id_1220"
    }
  }, [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "C110"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/10_Historians_and_Intellectual_Life#page_1",
      "id": "id_1221"
    }
  }, [_vm._v("Historians and Intellectual Life in the Civil War Era")])]), _vm._v(" "), _c('p', {
    staticClass: "C124"
  }, [_c('em', [_vm._v("Lorien Foote")])]), _vm._v(" "), _c('p', {
    staticClass: "C110"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/11_U_S__Sanitary_Commission_Physici#page_19",
      "id": "id_1222"
    }
  }, [_vm._v("U.S. Sanitary Commission Physicians and the Transformation of American Health Care")])]), _vm._v(" "), _c('p', {
    staticClass: "C124"
  }, [_c('em', [_vm._v("Kathryn Shively Meier")])]), _vm._v(" "), _c('p', {
    staticClass: "C110"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Civil_War_Cybernetics__Medicine#page_41",
      "id": "id_1211",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Civil War Cybernetics: Medicine, Modernity, and the Intellectual Mechanics of Union")])]), _vm._v(" "), _c('p', {
    staticClass: "C124"
  }, [_c('em', [_vm._v("Susan-Mary Grant")])]), _vm._v(" "), _c('p', {
    staticClass: "C110"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_To_Save_the_Afflicted_Union__Rac#page_64",
      "id": "id_1212",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("To Save the Afflicted Union: Race, Civic Health, and the Sanitary Front")])]), _vm._v(" "), _c('p', {
    staticClass: "C124"
  }, [_c('em', [_vm._v("Richard Newman")])]), _vm._v(" "), _c('p', {
    staticClass: "C110"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_John_Codman_Ropes__A_Lawyer_s_Hi#page_87",
      "id": "id_1213",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("John Codman Ropes: A Lawyer’s Historian")])]), _vm._v(" "), _c('p', {
    staticClass: "C124"
  }, [_c('em', [_vm._v("Richard F. Miller")])]), _vm._v(" "), _c('p', {
    staticClass: "C110"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Save_a_School_to_Save_a_Nation#page_110",
      "id": "id_1214",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Save a School to Save a Nation: Faculty Responses to the Civil War at Midwestern Universities")])]), _vm._v(" "), _c('p', {
    staticClass: "C124"
  }, [_c('em', [_vm._v("Julie Mujic")])]), _vm._v(" "), _c('p', {
    staticClass: "C110"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Lessons_of_War__Three_Civil_War#page_129",
      "id": "id_1215",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lessons of War: Three Civil War Veterans and the Goals of Postwar Education")])]), _vm._v(" "), _c('p', {
    staticClass: "C124"
  }, [_c('em', [_vm._v("Kanisorn Wongsrichanalai")])]), _vm._v(" "), _c('p', {
    staticClass: "C110"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_The_Rebels__Last_Device___Theod#page_153",
      "id": "page_xi",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“The Rebels’ Last Device”: Theodore R. Davis and Faithful Representations of Black Soldiers during the Civil War")])]), _vm._v(" "), _c('p', {
    staticClass: "C124"
  }, [_c('em', [_vm._v("Niki Lefebvre")])]), _vm._v(" "), _c('p', {
    staticClass: "C110"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_For_Their_Adopted_Home__Native_N#page_174",
      "id": "id_1216",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("For Their Adopted Home: Native Northerners in the South during the Secession Crisis")])]), _vm._v(" "), _c('p', {
    staticClass: "C124"
  }, [_c('em', [_vm._v("David Zimring")])]), _vm._v(" "), _c('p', {
    staticClass: "C110"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Thomas_F__Meagher__Patrick_R__Gu#page_193",
      "id": "id_1223",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Thomas F. Meagher, Patrick R. Guiney, and the Meaning of the Civil War for Irish America: The Questions of Nationalism, Citizenship, and Human Rights")])]), _vm._v(" "), _c('p', {
    staticClass: "C124"
  }, [_c('em', [_vm._v("Christian G. Samito")])]), _vm._v(" "), _c('p', {
    staticClass: "C110"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_This_Most_Unholy_and_Destructiv#page_217",
      "id": "id_1224",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“This Most Unholy and Destructive War”: Catholic Intellectuals and the Limits of Catholic Patriotism")])]), _vm._v(" "), _c('p', {
    staticClass: "C125"
  }, [_c('em', [_vm._v("William Kurtz")])]), _vm._v(" "), _c('p', {
    staticClass: "C124"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Notes#page_237",
      "id": "id_1218",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])])]), _vm._v(" "), _c('p', {
    staticClass: "C124"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/xhtml/22_List_of_Contributors#page_289",
      "id": "id_1217",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("List of Contributors")])])]), _vm._v(" "), _c('p', {
    staticClass: "C124"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/xhtml/23_Index#page_293",
      "id": "id_1225",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f73dfb3c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/06_Contents.vue
// module id = 75
// module chunks = 0